module.exports = __webpack_public_path__ + "fonts/HelveticaNeue-UltraLight.8c77d0d4.eot";